import { useQuery } from "@apollo/client/react";

import { Maybe } from "types/generated";

import { GET_BLOB_STORAGE_INTEGRATION } from "./gql";

const useGetBlobStorageIntegration = (id: Maybe<string>) => {
  const { data, loading, error } = useQuery(GET_BLOB_STORAGE_INTEGRATION, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.blobStorageIntegration,
    isPageLoading: loading && !data?.blobStorageIntegration,
    error,
  };
};

export default useGetBlobStorageIntegration;
